export enum SearchDomain {
  PURCHASE_ORDER = 'purchaseOrder',
  PURCHASE_REQUISITION = 'purchaseRequisition',
  CONTRACT = 'contract',
  SOURCING_PROJECT = 'sourcingProject',
}

// this is the order the domains will have in the ui
export const searchDomains: SearchDomain[] = [
  SearchDomain.PURCHASE_ORDER,
  SearchDomain.PURCHASE_REQUISITION,
  SearchDomain.CONTRACT,
  SearchDomain.SOURCING_PROJECT,
];
